/* eslint-disable import/prefer-default-export */
import rights from '../../../../components/rights';
import { checkPricingAccess } from '$$helpers/pricingHelper';

export const getBlockedItemsByRights = (instance, projectId) => {
  const blockItems = [];

  // mass change condition
  if (!rights.project.hasRightSomeOne(projectId, [
    'static_fields',
    'delete_task',
    'static_fields_4_only',
    'custom_field_edit',
  ]) || !checkPricingAccess('bulk_change')) {
    blockItems.push('select_task_for_masschange');
  }

  // check jira project
  const project = instance.ganttDataApi.getProjectItem(projectId);

  if (project.is_jira) {
    blockItems.push('select_task_for_masschange');
  }

  if (!rights.project.hasRight(projectId, 'create_task')) {
    blockItems.push(...[
      'add_subtask',
      'add_sibling_task',
      'add_sibling_milestone',
      'add_child_milestone',
      'move_indent',
      'move_outdent',
      'convert_in_milestone',
      'convert_in_task',
      'copy_paste_settings',
      'separatorBefore',
      'separatorAfterCopyPaste',
    ]);
  }

  if (!rights.project.hasRight(projectId, 'delete_task')) {
    blockItems.push(...[
      'delete_task',
    ]);
  }

  if (!rights.project.hasRight(projectId, 'copypast')) {
    blockItems.push(...[
      'copy_task',
      'paste_task',
      'paste_task_disabled',
    ]);
  }

  if (!rights.project.hasRight(projectId, 'static_fields')) {
    blockItems.push(...[
      'choose_task_color',
      'choose_project_color',
    ]);
  }

  return blockItems;
};
